
/**
 * \@docs-private
 * @param {?} id
 * @return {?}
 */
export function getMdSortDuplicateMdSortableIdError(id: string): Error {
  return Error(`Cannot have two MdSortables with the same id (${id}).`);
}
/**
 * \@docs-private
 * @return {?}
 */
export function getMdSortHeaderNotContainedWithinMdSortError(): Error {
  return Error(`MdSortHeader must be placed within a parent element with the MdSort directive.`);
}
/**
 * \@docs-private
 * @return {?}
 */
export function getMdSortHeaderMissingIdError(): Error {
  return Error(`MdSortHeader must be provided with a unique id.`);
}
